import { useEffect, useState } from "react";
import { FindItemIcon, TelegramIcon } from "../../../assets/icons";
import { Header } from "../../../components/header/header";
import { TextInput } from "../../../components/textInput/textInput";
import { KnowledgeButton } from "./knowledgeButton";
import { Button } from "../../../components/button/button";
import { useOpenPage } from "../../../hooks/useOpenPage";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import styles from "./knowledgeBasePage.module.css";

export const KnowledgeBasePage = () => {
    const [materials, setMaterials] = useState([]);
    const [search, setSearch] = useState("");
    const openPage = useOpenPage();

    useEffect(() => {
        KnowledgeAPI
            .fetchMaterials()
            .then((res) => setMaterials(res))
            .catch(() => setMaterials([]))
    }, [])

    return (
        <>
            <Header title="База знаний" />

            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

            <div className={styles.materials_container}>
                <Button onClick={openPage("experts")} text="Спроси эксперта" icon={<TelegramIcon />} />

                {
                    materials.filter(el => el.title.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                        <KnowledgeButton key={data.id} text={data.title} imgSrc={data.icon} link={`/knowledge/${data.id}`} />
                    )
                }
            </div>
        </>
    )
}
